import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import { MusicClientContext } from '../../context/MusicClientContext';
import CustomRadio from '../../../common/components/CustomRadio';
import CustomButton from '../../../common/components/CustomButton';
import { showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicPermissionToUseBulkEditPopup({
  initialDefaultPermissionToUse,
  onCancel,
  onDone,
} : {
  initialDefaultPermissionToUse: number,
  onCancel: () => void,
  onDone: (bulkPermissionToUse: number) => void,
}) {

  const { saveBulkPermissionToUse } = React.useContext(MusicClientContext);

  const [
    bulkPermissionToUse,
    setBulkPermissionToUse,
  ] = React.useState('2');

  const [
    defaultPermissionToUse,
    setDefaultPermissionToUse,
  ] = React.useState(`${initialDefaultPermissionToUse}`);

  const bulkPermissionToUseOptions = [
    { value: '1', title: '全て「許可する」に変更' },
    { value: '2', title: '変更しない' },
    { value: '0', title: '全て「許可しない」に変更' },
  ];

  const defaultPermissionToUseOptions = [
    { value: '1', title: '許可する' },
    { value: '0', title: '許可しない' },
  ];

  const handleSubmit = () => {
    saveBulkPermissionToUse(parseInt(bulkPermissionToUse, 10), parseInt(defaultPermissionToUse, 10)).then((responseData) => {
      if (responseData.result) {
        onDone(parseInt(defaultPermissionToUse, 10));
      } else {
        showErrorFlush('入力内容に不備があります。');
      }
    });
  };

  return (
    <PopupContainer title="利用許可設定の一括変更" onClose={() => { onCancel(); }}>
      <div>
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              <dt>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="/">すでにアップロード済の曲の設定を一括変更しますか？</label>
              </dt>
              <dd>
                <CustomRadio
                  options={bulkPermissionToUseOptions}
                  value={bulkPermissionToUse}
                  setValue={(value) => setBulkPermissionToUse(value)}
                />
              </dd>
            </dl>
            <dl>
              <dt>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="/">今後アップロードする曲の初期設定はどちらにしますか？</label>
              </dt>
              <dd>
                <CustomRadio
                  options={defaultPermissionToUseOptions}
                  value={defaultPermissionToUse}
                  setValue={(value) => setDefaultPermissionToUse(value)}
                />
              </dd>
            </dl>
            <p className="top_line" />
            <ul>
              <li className="bt">
                <CustomButton type="default" onClick={() => handleSubmit()}>保存</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </PopupContainer>
  );
}
